import { ActionPattern, select, take } from 'redux-saga/effects';

export const getOpenedWebsocket = async (websocketChannel: WebSocket): Promise<WebSocket> => {
    if (WebSocket.OPEN === websocketChannel.readyState) {
        return websocketChannel;
    }
    await new Promise((resolve) => websocketChannel.addEventListener('open', resolve, { once: true }));
    return websocketChannel;
};

// It could be used like this:

// function* someSaga() {
//   yield call(waitFor, state => getCurrentUser(state) != null);
//   // the user is logged in by now
// }
export function* waitForSaga(selector, pattern: ActionPattern = '*') {
    if (yield select(selector)) return;

    while (true) {
        yield take(pattern); // (1a)
        if (yield select(selector)) return;
    }
}


export function messageToObject<T = any>(event: MessageEvent<T>) {
    if (typeof event.data !== 'string') {
        return;
    }
    const messageData: T = JSON.parse(event.data);
    return messageData as T;
};
